import type { NewDevelopmentCharge } from '@/services/apis/getNewDevelopmentCharge/schemas';
import type { BroadbandPlanCardDataResponse } from '@/services/apis/getPlanCard/broadband/broadband.schema';
import type { MobilePlanCardDataResponse } from '@/services/apis/getPlanCard/mobile/mobile.schema';
import { createSliceWithImmer } from 'zustand-slices/immer';

type ShoppingCartSlice = {
  isShoppingCartOpen: boolean;
  latestMobileOffer: MobilePlanCardDataResponse | null;
  latestBroadbandOffer: BroadbandPlanCardDataResponse | null;
  latestNewDevelopmentCharge: NewDevelopmentCharge | null;
};

type ShoppingCartSliceActions = {
  setLatestMobileOffer: (
    latestMobileOffer: MobilePlanCardDataResponse | null
  ) => (state: ShoppingCartSlice) => void;
  setLatestBroadbandOffer: (
    latestBroadbandOffer: BroadbandPlanCardDataResponse | null
  ) => (state: ShoppingCartSlice) => void;
  setIsShoppingCartOpen: (
    isShoppingCartOpen: boolean
  ) => (state: ShoppingCartSlice) => void;
  setLatestNewDevelopmentCharge: (
    latestNewDevelopmentCharge: NewDevelopmentCharge | null
  ) => (state: ShoppingCartSlice) => void;
};

export const shoppingCartSlice = createSliceWithImmer<
  'shoppingCartStore',
  ShoppingCartSlice,
  ShoppingCartSliceActions
>({
  name: 'shoppingCartStore',
  value: {
    latestMobileOffer: null,
    latestBroadbandOffer: null,
    latestNewDevelopmentCharge: null,
    isShoppingCartOpen: false,
  },
  actions: {
    setLatestMobileOffer: (latestMobileOffer) => (state) => {
      state.latestMobileOffer = latestMobileOffer;
    },
    setLatestBroadbandOffer: (latestBroadbandOffer) => (state) => {
      state.latestBroadbandOffer = latestBroadbandOffer;
    },
    setIsShoppingCartOpen: (isShoppingCartOpen) => (state) => {
      state.isShoppingCartOpen = isShoppingCartOpen;
    },
    setLatestNewDevelopmentCharge: (latestNewDevelopmentCharge) => (state) => {
      state.latestNewDevelopmentCharge = latestNewDevelopmentCharge;
    },
  },
});
